import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

//import { disableReactDevTools } from '@fvilers/disable-react-devtools';



const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');
const container = document.getElementById('root');

const root = createRoot(container);

console.log(process.env.NODE_ENV);

root.render(
    <BrowserRouter basename={baseUrl}>  
        
            <App />   
        
    </BrowserRouter>);

registerServiceWorker();
